export default __webpack_public_path__ + "static/media/plug_treadmill.5920be0a.svg";